<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Szablon email'" [name]="'Szablon email'"></app-breadcrumb>
<div class="risk-configuration-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row"  >
          <h3>Aktualny szablon TU</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="center center"  *ngIf="TU">
         <button *ngIf="!fileLocation" (click)="download()" mat-stroked-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz</span></button>
          <button *ngIf="!fileLocation" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
        </div>
<div>

</div>
        <app-file-drag-and-drop *ngIf="fileLocation" [multiple]="false" [fileControl]="fileControl" ></app-file-drag-and-drop>



        <div fxLayout="row">
          <app-dict-insurance-companies
            fxFlex="100" label="TU"
            [required]="true"
            [control]="insuranceCompanyControl"
            [companyId]="importCompanyId"
            (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
          ></app-dict-insurance-companies>
        </div>


         <div fxLayout="row"  *ngIf="TU">
          <angular-editor fxFlex="100"  [config]="editorConfig" [formControl]="contentEmailControl"></angular-editor>
        </div>




      </mat-card>
    </div>

  </div>
  <div fxLayout="row" fxFlex.lt-md="100%" >
    <div fxFlex="100">
      <mat-card>
        <div fxLayout="row">
          <h3>Dodanie tabelki   do treści maila</h3>
        </div>

        <div fxLayout="column">
          {{temp}}
        </div>
      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
  </div>
</div>
